export default __webpack_public_path__ + "static/LogoOldToken-1920e5df230a6037759abbef081cc9fb.svg";